import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { buildApiUrl } from '../../../core/config/api.constants';
import { TournamentUserRole, TournamentUserRoleCreate } from '../models/tournament-user-role.model';

@Injectable({
  providedIn: 'root',
})
export class TournamentUserRoleService {
  private apiService = inject(ApiService);

  getRoles(tournamentId: number): Observable<TournamentUserRole[]> {
    return this.apiService.customGet<TournamentUserRole[]>(
      buildApiUrl(`/api/tournaments/${tournamentId}/roles/`)
    );
  }

  addRole(tournamentId: number, data: TournamentUserRoleCreate): Observable<TournamentUserRole> {
    return this.apiService.customPost<TournamentUserRole>(
      buildApiUrl(`/api/tournaments/${tournamentId}/roles/`),
      data
    );
  }

  removeRole(tournamentId: number, roleId: number): Observable<void> {
    return this.apiService.customDelete<void>(
      buildApiUrl(`/api/tournaments/${tournamentId}/roles/${roleId}`)
    );
  }

  getMyPermissions(tournamentId: number): Observable<string[]> {
    return this.apiService.customGet<string[]>(
      buildApiUrl(`/api/tournaments/${tournamentId}/roles/me`)
    );
  }
}
